import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import { SettingsProvider } from './context/settings';
import './assets/css/styles.css';
import './i18n';

const savedLang = localStorage.getItem('app_language') || 'en';
if (savedLang === 'ar') {
  import('./assets/css/rtl.css');
}
document.documentElement.dir = savedLang === 'ar' ? 'rtl' : 'ltr';
document.documentElement.lang = savedLang;

function App() {
  return (
    <BrowserRouter>
      <SettingsProvider>
        <AppRoutes />
      </SettingsProvider>
    </BrowserRouter>
  );
}

export default App;
